import React from 'react';
import { Botao, EstadoVazio } from '../egora';
import './casca.css';

/** Tela de último recurso, mostrada quando algum componente quebra. Não depende da casca. */
export default function EstadoErroInesperado() {
  return (
    <div className="sj casca-pagina casca-pagina--inteira">
      <h1 className="sj-oculto">Algo deu errado</h1>
      <EstadoVazio
        icone="error"
        titulo="Algo deu errado nesta tela"
        texto="Tente de novo. Se o problema continuar, avise o suporte."
        acao={(
          <div className="casca-pagina__acoes">
            <Botao icone="refresh" onClick={() => window.location.reload()}>Tentar de novo</Botao>
            <Botao variante="secundario" icone="home" onClick={() => window.location.assign('/')}>Ir para a Home</Botao>
          </div>
        )}
      />
    </div>
  );
}
